<template>
  <div>
    <v-banner color="success" dark v-if="isSignupSuccess">
      <v-avatar slot="icon" size="40">
        <v-icon>mdi-check-circle</v-icon>
      </v-avatar>
      Your account is ready to go. Sign in with your email address as username, and the temporary password we emailed you.
    </v-banner>
    <div class="login-div">
      <amplify-authenticator></amplify-authenticator>
    </div>
  </div>
</template>

<script>
import { awsAmplifyComponents, AmplifyEventBus } from "aws-amplify-vue";
// import { components } from "aws-amplify-vue";

export default {
  name: "Login",
  components: {
    ...awsAmplifyComponents
    // ...components
  },
  props: {
    msg: String
  },
  data() {
    return {
      isSignupSuccess: false
    };
  },
  computed: {},
  created() {
    localStorage.removeItem("signup-data");
    let params = new URLSearchParams(window.location.search);
    if (params.get("signup") == "success") {
      this.isSignupSuccess = true;
    } else {
      this.isSignupSuccess = false;
    }
    let vueThis = this;
    if (vueThis.$root.$children[0].isAuthenticated && this.$route.path == "/") {
      // vueThis.$router.replace({ name: "customers" });
    }
    setTimeout(function checkToken() {
      if (
        vueThis.$root.$children[0] &&
        !vueThis.$root.$children[0].isAuthenticated
      ) {
        vueThis.$root.$children[0].token = localStorage.getItem("access_token");
      }
      setTimeout(checkToken, 3000);
    }, 3000);
    AmplifyEventBus.$on("authState", async info => {
      if (info == "signedIn") {
        await vueThis.$root.$children[0].startup();
        if (this.$route.name != "customers") {
          // this.$router.replace({ name: "customers" });
        }
      } else if (info == "signedOut") {
        vueThis.$router.replace({ name: "login" });
      }
    });
  },
  updated() {
    if (this.$root.$children[0].isAuthenticated) {
      if (this.$route.name != "customers") {
        // this.$router.replace({ name: "customers" });
      }
    }
  },
  methods: {}
};
</script>

<style scoped lang="stylus"></style>
